export default {"src":"/_next/static/media/arrow-long-narrow-right.4d94f4e8.svg","height":35,"width":72,"blurWidth":0,"blurHeight":0};